import { classnames } from 'helpers/utils';
import { PlayIconFilledIcon } from 'assets/icons';
import LegacyAnimationGif from 'assets/gif/legacy-animation.gif';
import styles from './legacy-video-section.module.scss';

type LegacyVideoSectionProps = {
  showVideo: () => void;
};

const LegacyVideoSection: React.FC<LegacyVideoSectionProps> = ({
  showVideo,
}) => (
  <div className={styles.contentLeft}>
    <span className={classnames(styles.title, 'text__heading4__gray800')}>
      Create a legacy that will stand the test of time.
    </span>
    <div className={styles.videoWrapper}>
      <img
        src={LegacyAnimationGif}
        alt="Legacy animation"
        className={styles.video}
      />
      <button
        type="button"
        className={styles.playButton}
        onClick={showVideo}
        aria-label="Play video"
      >
        <PlayIconFilledIcon fill="white" />
      </button>
    </div>
  </div>
);

export { LegacyVideoSection };
